<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { EntityListPage, getAggregatorsLookup, type EntityConfig } from '@botto/core';
import { senderNamesStore } from '../../api';
import type { SenderName } from '../../api';

const aggregatorsLookup = getAggregatorsLookup();

onMounted(() => { void aggregatorsLookup.ensureLoaded(); });

const config = computed<EntityConfig<SenderName>>(() => ({
  title: 'Имя отправителя',
  titlePlural: 'Имена отправителей',
  popupWidth: 560,
  columns: [
    { dataField: 'id', caption: 'ID', dataType: 'number', width: 80 },
    { dataField: 'name', caption: 'Название' },
    { dataField: 'value', caption: 'Значение' },
    {
      dataField: 'aggregator_id',
      caption: 'Агрегатор',
      dataType: 'number',
      calculateDisplayValue: (row) => aggregatorsLookup.labelOf(row.aggregator_id),
    },
  ],
  fields: [
    { dataField: 'id', label: 'ID', editOnly: true, editorOptions: { readOnly: true } },
    { dataField: 'name', label: 'Название', required: true },
    { dataField: 'value', label: 'Значение', required: true },
    { dataField: 'aggregator_id', label: 'Агрегатор', required: true, lookup: aggregatorsLookup },
  ],
}));
</script>

<template>
  <EntityListPage :config="config" :store="senderNamesStore" />
</template>
